import React from 'react';
import {Button, Result} from 'antd';
import {useLocation, useNavigate} from 'react-router-dom';

const ForbiddenPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Result
      status="403"
      title="403"
      subTitle={`접근 권한이 없습니다. (${location.state?.from || ''})`}
      extra={<Button type="primary" onClick={() => navigate('/')}>홈</Button>}
    />
  );
};
export default ForbiddenPage;

